"use client"

import { forwardRef } from "react"
import type { LucideIcon } from "lucide-react"

import { cn } from "@/lib/utils"

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: LucideIcon
  error?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, icon: Icon, error, ...props }, ref) => {
    return (
      <div className="relative">
        {Icon && (
          <Icon className="pointer-events-none absolute top-1/2 left-4 h-5 w-5 -translate-y-1/2 text-text-400" />
        )}
        <input
          ref={ref}
          className={cn(
            "text-body w-full rounded-xl border border-background-200 bg-white py-3 text-text-950 transition-all",
            "placeholder:text-text-400",
            "hover:border-background-300",
            "focus:border-primary-600 focus:ring-[3px] focus:ring-primary-500/50 focus:outline-none",
            "disabled:cursor-not-allowed disabled:opacity-50",
            Icon ? "pr-4 pl-12" : "px-4",
            error && "border-error focus:ring-error",
            className
          )}
          {...props}
        />
      </div>
    )
  }
)

Input.displayName = "Input"
